var map = {
	"./pop_icon_api_1.png": "biwR",
	"./pop_icon_dy_3.png": "mnCi",
	"./pop_icon_gzh_4.png": "6Pen",
	"./pop_icon_ks_2.png": "CS0x",
	"./pop_icon_wx_7.png": "EXfO",
	"./pop_icon_yy_6.png": "nLO8",
	"./pop_icon_zfb_5.png": "f2IA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5I1G";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home ^\.\/.*\.png$
// module id = 5I1G
// module chunks = 1